import React, { useState, useRef } from "react";
import { Box, TextField, Button, InputAdornment,IconButton, Snackbar, Alert, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
export default function CouponField({
  onApply,
}) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
  const { t } = useTranslation();
  const buttonRef = useRef(null);
    const [couponCode,setCouponCode] = useState(false);
  const handleExpand =() => {
    setCouponCode(true);
  }
  const handleApply = async () => {
    setLoading(true);
    try {
      const result = await onApply(code);
      if (result.success) {
        setNotification({
          open: true,
          message: `${t("discountApplied")}: ${result.newDiscount?.value || 0}− %`,
          severity: 'success'
        });
      } else if (result.warning)
        {
          setNotification({
            open: true,
            message: t("couponWarning"),
            severity: 'warning'
          });
        }
        else {
        setNotification({
          open: true,
          message: t("invalidCoupon"),
          severity: 'error'
        });
      }
    } catch (error) {
      setNotification({
        open: true,
        message: t("invalidCoupon"),
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setNotification({ ...notification, open: false });
  };
  if (couponCode === false) {
    return (
    <Box sx={{ mb: 2, display: 'flex', flexDirection: 'row', gap: 2, justifyContent:"space-between"}} >
        <Typography>
            {t("doYouHaveACoupon")} ?
          <br/>
        </Typography>
        <IconButton onClick={handleExpand} variant="contained" color="success">
          <AddCircleOutlinedIcon />
        </IconButton>
    </Box>)
  }

  return (
    <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 2, position: 'relative' }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <TextField
          fullWidth
          variant="outlined"
          label={t("coupoun")}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          disabled={loading}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocalOfferIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
            }
          }}
        />
        <Button
          ref={buttonRef}
          variant="contained"
          onClick={handleApply}
          disabled={loading || !code.trim()}
          className="dc-btn-primary"
          sx={{
            height: "56px",
            borderTopLeftRadius: 2,
            borderBottomLeftRadius: 2,
            boxShadow: "none",
            minWidth: 64,
          }}
        >
          <img src="/discounts.png" alt="Checkmark" width="25" height="25" />
        </Button>
      </Box>

      <Snackbar
        open={notification.open}
        autoHideDuration={2000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          position: 'absolute',
          mx: 2,
        }}
      >
        <Alert onClose={handleCloseNotification} severity={notification.severity} sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}